// Patches GridySlider autoplay to wait for the full video duration before
// advancing, instead of using a fixed timer. Manual arrow navigation always
// works immediately and resets the timer for the new slide.
(function patchVideoAwareSlider() {
  // Deferred scripts run in order after DOM parsing, so sliders are already
  // upgraded and initialized when this file executes.
  document.querySelectorAll('gridy-slider').forEach(function (slider) {
    if (!slider.config || !slider.config.autoplay) return;

    // Teardown existing autoplay so we start clean.
    slider.clearAutoplayTimer();
    slider.removeEventListener('mouseenter', slider.clearAutoplayTimer);
    slider.removeEventListener('mouseleave', slider.autoplayGridy);
    slider.removeEventListener('touchenter', slider.clearAutoplayTimer);
    slider.removeEventListener('touchleave', slider.autoplayGridy);

    // Replace clearAutoplayTimer to handle both setInterval and setTimeout ids.
    slider.clearAutoplayTimer = function () {
      clearInterval(this.config.timer);
      clearTimeout(this.config.timer);
      this.config.timer = null;
    }.bind(slider);

    // Replace autoplayGridy with a video-aware version.
    slider.autoplayGridy = function () {
      this.clearAutoplayTimer();

      var activeSlide = this.slides[this.config.current_slide];
      var video = activeSlide ? activeSlide.querySelector('video') : null;

      if (video) {
        var self = this;

        var scheduleNext = function () {
          var duration = video.duration;
          var delay = (duration && !isNaN(duration) && duration > 0)
            ? duration * 1000
            : self.config.autoplay_delay;

          self.config.timer = setTimeout(function () {
            self.config.timer = null;
            self.scrollByIPR('next');
            self.autoplayGridy();
          }, delay);
        };

        if (video.readyState >= 1) { // HAVE_METADATA
          scheduleNext();
        } else {
          // Metadata not yet loaded: use fallback delay and also listen for
          // loadedmetadata in case it arrives sooner than the fallback.
          self.config.timer = setTimeout(function () {
            self.config.timer = null;
            self.autoplayGridy(); // retry; metadata should be loaded by now
          }, self.config.autoplay_delay);

          video.addEventListener('loadedmetadata', function () {
            // Ignore if the slider already moved to a different slide since
            // this listener was registered (e.g. the user clicked an arrow
            // before metadata loaded) — acting on a stale video would hijack
            // the new slide's own timer with the wrong duration.
            if (self.slides[self.config.current_slide] !== activeSlide) return;
            if (!self.config.timer) {
              // Fallback already fired and advanced; nothing to do.
              return;
            }
            // Cancel the fallback and schedule based on real duration.
            clearTimeout(self.config.timer);
            self.config.timer = null;
            scheduleNext();
          }, { once: true });
        }
      } else {
        // Non-video slide: behave like the original setInterval.
        this.config.timer = setInterval(
          this.scrollByIPR.bind(this),
          this.config.autoplay_delay,
          'next'
        );
      }
    }.bind(slider);

    // Re-attach pause-on-hover with the new methods.
    slider.addEventListener('mouseenter', slider.clearAutoplayTimer);
    slider.addEventListener('mouseleave', slider.autoplayGridy);
    slider.addEventListener('touchenter', slider.clearAutoplayTimer);
    slider.addEventListener('touchleave', slider.autoplayGridy);

    // Re-attach arrow buttons so manual navigation resets the video timer.
    if (slider.buttons && slider.buttons.length) {
      slider.buttons.forEach(function (btn) {
        btn.removeEventListener('click', slider.boundOnArrowClick);
      });

      slider.boundOnArrowClick = function (e) {
        slider.clearAutoplayTimer();
        slider.scrollByIPR(e.currentTarget.dataset.direction);
        slider.autoplayGridy();
      };

      slider.buttons.forEach(function (btn) {
        btn.addEventListener('click', slider.boundOnArrowClick);
      });
    }

    // Kick off the patched autoplay.
    slider.autoplayGridy();
  });
}());
